export default __webpack_public_path__ + "static/media/ThinkContractEVM.2bad02b5415df12760554420e9ed17d0.webp";